module.exports = __webpack_public_path__ + "static/media/vn1.4835988e.jpg";